import React from 'react'
import PropTypes from 'prop-types'

// Material-UI
import { makeStyles } from '@material-ui/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Slide from '@material-ui/core/Slide'


const useStyles = makeStyles({
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: props => props.isIn ? 'unset' : 'none',
  },

  card: {
    minWidth: 360,
    maxWidth: 360,
    // margin: '64px auto',
  },

  logo: {
    height: 90,
    width: 'auto',
    textAlign: 'center',
    marginBottom: 16,
  },
})



/** Sign In Page */
const LoginCard = ({ isIn = false, children }) => {
  const classes = useStyles({ isIn })

  return (
    <div className={classes.container}>
      <Slide in={isIn} direction="down">
        <Card className={classes.card}>
          <CardContent>

            <div style={{ width: '100%', textAlign: 'center' }}>
              <img
                alt="Base Builders Logo"
                className={classes.logo}
                src={`/img/logo/logo_vertical.svg`}
              />
            </div>

            {children}
          </CardContent>
        </Card>
      </Slide>
    </div>
  )
}

LoginCard.propTypes = {
  isIn: PropTypes.bool,
  children: PropTypes.node,
}

export { LoginCard }
